import { render, staticRenderFns } from "./TableMenuPowerUser.vue?vue&type=template&id=4f08c6ec&scoped=true&"
import script from "./TableMenuPowerUser.vue?vue&type=script&lang=ts&"
export * from "./TableMenuPowerUser.vue?vue&type=script&lang=ts&"
import style0 from "./TableMenuPowerUser.vue?vue&type=style&index=0&id=4f08c6ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f08c6ec",
  null
  
)

export default component.exports